import React from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";

import css from "./SelectSingleSampleModal.module.css";
import { sampleMenuService } from "../../../../services/menu-services";
import { sampleMenuActions } from "../../../../store/slices/menu-slices";
import { ImageReusable } from "../../../../ui";

const SelectSingleSampleModal = ({ dish, setIsOpen }) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const { idPackForBack, idPackMealForBack, idMatching } = useSelector(
    (store) => store.sampleMenu
  );

  const { id, name, categories, price, cost, weight, weightNetto, img } = dish;

  const currentLanguage = i18n.language;
  const displayName = name?.[currentLanguage] || name?.["en"] || "Unknown Dish";
  const categoryName =
    categories
      .map((category) => category.name[currentLanguage] || category.name["en"])
      .join(", ") || t("unknown-category");

  const addSampleDish = async () => {
    try {
      const formatedData = {
        mealId: idPackMealForBack,
        packId: idPackForBack,
        dishId: id,
      };

      if (idMatching) {
        await sampleMenuService.updateSampleMenuDishes(
          idMatching,
          formatedData
        );
      } else {
        await sampleMenuService.addSampleMenuDishes(formatedData);
      }

      dispatch(sampleMenuActions.changeTrigger());
      setIsOpen(false);
      toast.success(t("modal-toast-success"));
    } catch (error) {
      console.error(t("modal-toast-creating-error"), error);
      toast.error(t("modal-toast-creating-error"));
    }
  };

  return (
    <section className={css.wrap} onClick={addSampleDish}>
      <div className={css.image}>
        <ImageReusable src={img} className={css.imageTag} alt="Food Image" />
      </div>

      <div className={css.name}>{displayName}</div>
      <div className={css.category}>{categoryName}</div>
      <div className={css.weight}>{weight}</div>
      <div className={css.weightNetto}>{weightNetto || 0}</div>
      <div className={css.cost}>{cost}</div>
      <div className={css.price}>{price}</div>
    </section>
  );
};

export { SelectSingleSampleModal };
